import React, { useState, useEffect } from "react";
import { parseISO, format } from "date-fns";
import "rsuite/dist/rsuite.min.css";
import { Pagination } from "rsuite";
import { Link } from "react-router-dom";
import axios from "axios";
import LoaderDiv from "../components/LoaderDiv";
import Seo from "../components/Seo";

const BlogPage = () => {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 6;

  const getData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/api/get_blog"
      );

      setBlogData(res.data);
      setTotalPages(Math.ceil(res.data.length / itemsPerPage));
    } catch (error) {
      console.log("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getData();
  }, []);

  const paginatedData = blogData.slice(
    (activePage - 1) * itemsPerPage,
    activePage * itemsPerPage
  );

  return (
    <div>
      <Seo
        title="Blog | Top Pharma Blogs - Bioversal Remedies"
        description="Read the latest pharma blogs by Bioversal Remedies."
        type="webapp"
        name="Bioversal Remedies"
      />

      <section className="animate__animated animate__fadeIn">
        <div className="container-fluid mt-5 p-0">
          <div className="bg_cont__45-blog ban__nerrr">
            <h2 style={{ color: "#fff" }}>Our Blogs</h2>
          </div>
        </div>

        <section style={{ marginTop: "50px" }}>
          <div className="row justify-content-center">
            {loading ? (
              <div className="d-flex justify-content-center">
                <LoaderDiv />
              </div>
            ) : (
              paginatedData.map((item) => {
                const dateObject = parseISO(item?.created_at);
                const formattedDate = format(dateObject, "MMM dd, yyyy");

                return (
                  <div
                    key={item?.id}
                    className="col-md-3 col-sm-6 col-12 d-flex justify-content-center each-card"
                  >
                    <div className="card card-shadow">
                      <div className="card-header">
                        <img
                          src={item?.image}
                          alt={item?.title}
                          style={{
                            width: "100%",
                            borderRadius: "10px 10px 0 0",
                          }}
                        />
                      </div>

                      <div className="card-body" style={{ height: "250px" }}>
                        <small>{formattedDate}</small>

                        <div
                          className="card-title mb-3"
                          style={{
                            fontSize: "22px",
                            fontWeight: "600",
                            color: "#004960",
                            borderBottom: "2px solid #F28535",
                            paddingBottom: "5px",
                          }}
                        >
                          {item?.title}
                        </div>

                        <p className="card-description">
                          {item?.description_front?.slice(0, 200) + "..."}
                        </p>
                      </div>

                      <div className="card-footer d-flex justify-content-end">
                        <Link to={`/${item.slug}/`}>
                          <button className="btn btn_read_more">
                            Read More
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </section>

        <div className="d-flex justify-content-center my-5">
          <Pagination
            prev
            last
            next
            first
            size="lg"
            total={totalPages}
            activePage={activePage}
            onSelect={handlePageChange}
          />
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
